<template lang="pug">
.pa-2
  v-dialog(v-model='isModalExportar'  fullscreen)
    parametros-exportacion(
      v-if="isModalExportar",
      :id="idReporte",
      @close="closeDialogExportar",
      :preview="tipoPreview"
      :tipo="tipoReporte",
      :filtros="filtrosDraft"
    )
  v-card.mx-auto.elevation-1
    .d-flex
      .flex-1
        v-card-title.pa-3.pl-4
          span.font-weight-700(:class="{'font-size-17' : isMovil}") Visualizador de reportes
        v-card-subtitle.pb-3.font-size-13 Configura los parametros y exporta
    v-divider
    v-sheet
      .pa-1( dense)
        .d-flex.ai-center
          .flex-1(v-if="tipoPreview === 'save'")
            strong.font-size-13.is-bold.ml-4 {{datosReporte.titulo}}
          .flex-1(v-else)
            strong.font-size-13.is-bold.ml-4 Reporte de tipo draft
          v-card.d-flex.elevation-0.ai-center
            v-btn.mx-1( fab color="primary" @click="fetchDatosReporte()")
              v-icon sync
            v-btn.mx-1( fab color="success" @click="openDialogExportar()")
              v-icon import_export
      v-divider
      .box-table(
        v-infinite-scroll='fetchByScroll',
        infinite-scroll-disabled='disabledScrollExcecute',
        infinite-scroll-distance='2'
      )
        v-data-table.overflow-y-auto(
          :headers='headerTable'
          dense
          fixed-header
          :items='lista'
          :disable-pagination="true"
          hide-default-footer
        )
          template(v-slot:item.descripcionFalla='{ item }')
            strong.font-size-11(v-if="item.codigoFalla") {{item.codigoFalla}}
            strong.font-size-11  - {{item.descripcionFalla}}
          template(v-slot:item.descripcionEstado='{ item }')
            strong.font-size-11(v-if="item.estado") {{item.estado}}
            strong.font-size-11  - {{item.descripcionEstado}}
          template(v-slot:item.tipoticket='{ item }')
            span.font-size-11  {{item.tipoticket}}
          template(v-slot:item.fechaRegistro='{ item }')
            strong.font-size-11 {{item.fechaRegistro | formatoFecha}}
          template(v-slot:item.numeroInformeTecnico='{ item }')
            span.font-size-11  {{item.numeroInformeTecnico}}
          template(v-slot:item.serie='{ item }')
            span.font-size-11  {{item.serie}}
          template(v-slot:item.descripcion='{ item }')
            .d-flex.fd-column
              span.font-size-11  {{item.descripcion}}
              strong.font-size-11.primary--text  {{item.codigoArticulo}}
          template(v-slot:item.area='{ item }')
            span.font-size-11  {{item.area}}
          template(v-slot:item.tipoArea='{ item }')
            span.font-size-11  {{item.tipoArea}}
          template(v-slot:item.zonaGarantia='{ item }')
            span.font-size-11  {{item.zonaGarantia}}
          template(v-slot:item.actions="{ item, index }")
            .d-flex.ai-center(:class="{'ma-1' : !isMovil}")
              v-btn.mr-2( x-small color="info" @click="goTo('/ticket/' + item.numero)")
                v-icon.mr-1(size="15") visibility
                | ver ticket
          template(v-slot:item.razonSocial='{ item }')
            .d-flex.fd-column
              //- span.text-muted.font-size-11(v-if="item.codigoClienteSap") {{item.codigoClienteSap}}
              span.text-muted.font-size-11(v-if="item.codigoCliente") {{item.codigoCliente}}
              strong.font-size-11  {{item.razonSocial}}
          template(v-slot:item.abierto='{ item }')
            v-chip(small :color="item.abierto ? 'success' : 'error'")
              span.font-weight-700.font-size-11  {{ item.abierto ? 'Abierto' : 'Cerrado' }}
      v-divider
      v-card.pa-2.elevation-0
        small.font-size-11 {{lista.length}} registros encontrados
</template>
<script>
import moment from 'moment'
import { apiGet, apiPost, notify } from '../util/general'
import parametrosExportacion from './c_reporte_parametros_exportacion'
export default {
  props : ['tipo'],
  components : {
    'parametros-exportacion' : parametrosExportacion
  },
  data () {
    return {
      headerTable   : [
        {
          text : 'Numero',
          align: 'start',
          value: 'numero'
        },
        {
          text : 'Fecha',
          align: 'start',
          value: 'fechaRegistro'
        },
        {
          text : 'Tipo',
          align: 'start',
          value: 'tipoticket'
        },
        {
          text : 'Abierto',
          align: 'start',
          value: 'abierto'
        },
        {
          text: 'Etapa',
          align: 'start',
          value: 'etapaEstado'
        },
        {
          text : 'Estado',
          align: 'start',
          value: 'descripcionEstado'
        },
        {
          text : 'Cliente',
          align: 'start',
          value: 'razonSocial'
        },
        // {
        //   text: 'Cliente',
        //   align: 'start',
        //   value: 'razonSocial'
        // },
        // {
        //   text: 'Codigo falla',
        //   align: 'start',
        //   value: 'codigoFalla'
        // },
        // {
        //   text : 'Falla',
        //   align: 'start',
        //   value: 'descripcionFalla'
        // },
        // {
        //   text: 'Estado',
        //   align: 'start',
        //   value: 'estado'
        // },
        // {
        //   text: 'codigoTecnico',
        //   align: 'start',
        //   value: 'codigoTecnico'
        // },
        // {
        //   text: 'codigoTipoContrato',
        //   align: 'start',
        //   value: 'codigoTipoContrato'
        // },
        // {
        //   text: 'comentarioFalla',
        //   align: 'start',
        //   value: 'comentarioFalla'
        // },
        // {
        //   text: 'comentarioGeneral',
        //   align: 'start',
        //   value: 'comentarioGeneral'
        // },
        // {
        //   text: 'comproAqui',
        //   align: 'start',
        //   value: 'comproAqui'
        // },
        // {
        //   text: 'descripcion',
        //   align: 'start',
        //   value: 'descripcion'
        // },
        // {
        //   text: 'contrato',
        //   align: 'start',
        //   value: 'descripcionTipoContrato'
        // },
        // {
        //   text : 'Equipo',
        //   align: 'start',
        //   value: 'descripcionTipoEquipo'
        // },
        // {
        //   text: 'descripcionTipoInforme',
        //   align: 'start',
        //   value: 'descripcionTipoInforme'
        // },
        // {
        //   text: 'Anulará',
        //   align: 'start',
        //   value: 'diasParaAutoAnulacion'
        // },
        // {
        //   text: 'Direccion',
        //   align: 'start',
        //   value: 'direccion'
        // },
        // {
        //   text: 'emailTecnico',
        //   align: 'start',
        //   value: 'emailTecnico'
        // },
        {
          text : 'Taller',
          align: 'start',
          value: 'equipoIngresadoaATaller'
        },
        // {
        //   text: 'factura',
        //   align: 'start',
        //   value: 'factura'
        // },

        // {
        //   text: 'fechaUltimaActividad',
        //   align: 'start',
        //   value: 'fechaUltimaActividad'
        // },
        // {
        //   text: 'foto',
        //   align: 'start',
        //   value: 'foto'
        // },
        // {
        //   text: 'idCita',
        //   align: 'start',
        //   value: 'idCita'
        // },
        // {
        //   text: 'marca',
        //   align: 'start',
        //   value: 'marca'
        // },
        // {
        //   text: 'modelo',
        //   align: 'start',
        //   value: 'modelo'
        // },
        // {
        //   text: 'nombreTecnico',
        //   align: 'start',
        //   value: 'nombreTecnico'
        // },
        // {
        //   text: 'nombreUsuarioUltimaActividad',
        //   align: 'start',
        //   value: 'nombreUsuarioUltimaActividad'
        // },
        // {
        //   text: 'numeroContrato',
        //   align: 'start',
        //   value: 'numeroContrato'
        // },
        // {
        //   text : 'Informe',
        //   align: 'start',
        //   value: 'numeroInformeTecnico'
        // },
        // {
        //   text: 'origenUltimaActividad',
        //   align: 'start',
        //   value: 'origenUltimaActividad'
        // },
        {
          text : 'Serie',
          align: 'start',
          value: 'serie'
        },
        {
          text : 'Articulo',
          align: 'start',
          value: 'descripcion'
        },
        // {
        //   text: 'sigueEnGarantia',
        //   align: 'start',
        //   value: 'sigueEnGarantia'
        // },
        // {
        //   text: 'tiempoRespuesta',
        //   align: 'start',
        //   value: 'tiempoRespuesta'
        // },
        {
          text: 'Area',
          align: 'start',
          value: 'tipoArea'
        },
        // {
        //   text: 'Zona',
        //   align: 'start',
        //   value: 'tipoArea'
        // },
        // {
        //   text: 'tipoEquipo',
        //   align: 'start',
        //   value: 'tipoEquipo'
        // },
        // {
        //   text: 'tipoInforme',
        //   align: 'start',
        //   value: 'tipoInforme'
        // },
        // {
        //   text: 'usuario',
        //   align: 'start',
        //   value: 'usuario'
        // }
        // {
        //   text: 'Area',
        //   align: 'start',
        //   value: 'tipoArea'
        // },
        // {
        //   text: 'usuarioUltimaActividad',
        //   align: 'start',
        //   value: 'usuarioUltimaActividad'
        // },
        // {
        //   text: 'vigenciaContrato',
        //   align: 'start',
        //   value: 'vigenciaContrato'
        // },
        // {
        //   text: 'zona',
        //   align: 'start',
        //   value: 'zona'
        // },
        {
          text: 'Zona',
          align: 'start',
          value: 'zonaGarantia'
        },
        { text: 'Acciones', value: 'actions', sortable: false, width: '50' }
      ],
      lista                    : [],
      numeroRecnum             : 0,
      disabledScrollExcecute   : true,
      noMore                   : false,
      isScroll                 : true,
      idReporte                : this.$route.query.id,
      tipoPreview              : this.tipo || 'draft',
      filtrosDraft             : null,
      tipoReporte              : this.$route.query.tipoReporte,
      datosReporte             : {},
      isModalExportar          : false,
      columnasTicket           : [],
      isSeleccionarTodoColumnas: false
    }
  },
  created () {
    var vm = this
    vm.handlerParseFormatQuerString(err => {
      if (err) {
        notify(vm, 'error', 'Error', err)
        return
      }

      if (vm.tipoPreview === 'save') vm.fetch()
      else vm.fetchDatosReporte()
    })
  },
  filters : {
    formatoFecha: function (value) {
      if (!value) return ''
      return moment.utc(value).format('DD/MM/YYYY HH:ss')
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods : {
    handlerParseFormatQuerString (callback) {
      var vm = this
      if (vm.tipoPreview === 'draft') {
        vm.filtrosDraft = null
        var parametrosQuery = vm.$route.query
        if (parametrosQuery.tipoReporte === 'basico') {
          vm.filtrosDraft = parametrosQuery
          callback(null)
        } else if (parametrosQuery.tipoReporte === 'avanzado') {
          vm.filtrosDraft = []
          Object.keys(parametrosQuery).forEach(e => {
            var value = parametrosQuery[e].split(',')
            vm.filtrosDraft.push({
              columna  : { valor : e },
              condicion: { valor : value[0] },
              value    : value[1]
            })
          })
          callback(null)
        } else {
          callback('En los parametros no existe ningun tipo de reporte valido')
        }
      } else {
        callback(null)
      }
    },
    openDialogExportar () {
      var vm = this
      vm.isModalExportar = true
    },
    closeDialogExportar () {
      var vm = this
      vm.isModalExportar = false
    },
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetch()
    },
    fetchDatosReporte () {
      var vm = this
      var url = 'ticket/obtener/reporte'
      if (!vm.isScroll) {
        vm.lista = []
        vm.numeroRecnum = 0
      }

      vm.disabledScrollExcecute = true
      vm.noMore                 = false
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo listado de tickets' })
      var obj = {
        idReporte   : vm.idReporte,
        numeroRecnum: vm.numeroRecnum,
        tipoPreview : vm.tipoPreview,    // save or draft
        tipoReporte : vm.tipoReporte,    // basico or avanzado
        filtrosDraft: vm.filtrosDraft    // filtros basicos o avanzados
      }

      apiPost(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExcecute = true
        } else {
          vm.numeroRecnum = data.numeroRecnum
          vm.disabledScrollExcecute = false
        }
      }, function (err) {
        vm.disabledScrollExcecute = true
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isScroll  = false
        vm.$store.dispatch('transaccion', {isProceso : false})
      })
    },
    fetch () {
      var vm = this
      vm.datosReporte = {}
      var url = 'reporte/obtener'
      vm.disabledScrollExcecute = true
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo datos del reporte' })
      vm.noMore                 = false
      var parametrosQuery = vm.$route.query
      var obj = {
        id         : vm.idReporte,
        tipoListado: parametrosQuery.default
      }
      console.log('objjjj', obj)
      apiGet(vm, url, obj, function (data) {
        console.log('daaaaaaaaa', data)
        vm.datosReporte = data.lista[0]
        vm.fetchDatosReporte()
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
      })
    },
    goTo (page) {
      // var vm = this
      window.open(page, '_blank')
    }
  }
}
</script>
<style  lang="stylus" scoped>
.box-table
  height calc(100vh - 225px)
  overflow-y auto
</style>



// WEBPACK FOOTER //
// c_reporte_previsualizar.vue?2f97feef